import { render, staticRenderFns } from "./AboutOnlineRecruit.vue?vue&type=template&id=79718bc6"
import script from "./AboutOnlineRecruit.vue?vue&type=script&lang=js"
export * from "./AboutOnlineRecruit.vue?vue&type=script&lang=js"
import style0 from "./AboutOnlineRecruit.vue?vue&type=style&index=0&id=79718bc6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports